import {createNavigationContainerRef} from '@react-navigation/native';

/**
 * Ref do NavigationContainer, compartilhada com quem é renderizado fora dele.
 *
 * O AppModalHost fica em App.tsx acima do <RoutesTab />, ou seja, fora do
 * NavigationContainer — então useNavigation() não funciona lá dentro. A modal
 * de comunicação precisa navegar ao tocar no CTA, e é por aqui que ela faz isso.
 */
export const navigationRef = createNavigationContainerRef();

export function navigate(name: string, params?: object) {
  if (navigationRef.isReady()) {
    // @ts-ignore — as rotas são tipadas em Routes.types.ts, mas o ref é genérico.
    navigationRef.navigate(name, params);
  }
}
